import { buildLink } from '@/helpers/slugHelper';
import React from 'react'
import { useCurrentRefinements } from 'react-instantsearch';
import styles from "../common/Breadcrumbs/Breadcrumbs.module.scss"

// Define the paths for which breadcrumbs should be hidden
export const collectionPath = [
  "/designer",
  "/new-arrivals",
  "/search",
  "/collection",
  "/sale",
];

function BreadCrumb(props) {
  const { items } = useCurrentRefinements(props);
  const [breadcrumbs, setBreadcrumbs] = React.useState([]);
  const [flag, setFlag] = React.useState(false);
  const [shouldHideBreadcrumbs, setShouldHideBreadcrumbs] = React.useState(false);
  let breadCrumbsArr = null;
  let ret = [];

  // Check if the current URL path is in the collectionPath array
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const pathShouldHide = collectionPath.some(path => window.location.pathname.includes(path));
      // Set shouldHideBreadcrumbs to true if pathShouldHide is true, otherwise false
      setShouldHideBreadcrumbs(!pathShouldHide);
    }
  }, []);

  //OS-5291 conscious gender filter is now removed
  //OS-5933 label to filter Occasion tag added to url to allow breadcrumb to be visible on plp
  const dataArray = Object.values(items).filter(item => item.attribute !== 'vendor' && item.attribute !== 'meta.color.base_color' && item.attribute !== 'price' && item.attribute !== 'meta.custom.us_size' && item.attribute !== 'named_tags.Occasion');

  // initializing level0,1 and 2 data
  const level0 = dataArray[dataArray.length - 3];
  const level1 = dataArray[dataArray.length - 2];
  const level2 = dataArray[dataArray.length - 1];

  var lastData;
  if ((level1?.refinements.length > 1 && level2?.refinements.length) || (level0?.attribute == "named_tags.categories.lvl0" && !level1?.attribute == "named_tags.categories.lvl1" && level2?.attribute == "named_tags.categories.lvl2")) {
    lastData = level0;
  }
  // if  level2  array length is more than 1 and  contains only level1 attribute
  else if ((level2?.refinements.length > 1) || (level1?.attribute == "named_tags.categories.lvl1" && !level0?.attribute == "named_tags.categories.lvl0" && !level2?.attribute == "named_tags.categories.lvl2")) {
    lastData = level1;
  } else {
    lastData = level2;
  }
  // Function to create breadcrumb links without accumulating levels
  const createBreadcrumbLinks = async () => {
    breadCrumbsArr = lastData?.refinements[0]?.value.split(">")
    let link = "/products";
    if(lastData?.attribute === 'named_tags.categories.lvl2') {
      link = await buildLink(breadCrumbsArr[0]?.trim());
      ret.push({
        link: link,
        text: breadCrumbsArr[0],
      })

      link = await buildLink(breadCrumbsArr[0]?.trim(),breadCrumbsArr[1]?.trim());
      ret.push( {
        link: link,
        text: breadCrumbsArr[1],
      })

      link = await buildLink(breadCrumbsArr[0]?.trim(),breadCrumbsArr[1]?.trim(),breadCrumbsArr[2]?.trim());
      ret.push( {
            link: link,
            text: breadCrumbsArr[2],
          })
      setBreadcrumbs(ret)
      setFlag(false)
    } 
    else if(lastData?.attribute === 'named_tags.categories.lvl1') {
      link = await buildLink(breadCrumbsArr[0]?.trim());
      ret.push({
        link: link,
        text: breadCrumbsArr[0],
      })

      link = await buildLink(breadCrumbsArr[0]?.trim(),breadCrumbsArr[1]?.trim());
      ret.push({
        link: link,
        text: breadCrumbsArr[1],
      })
      setBreadcrumbs(ret)
      setFlag(false)
    } else if(lastData?.attribute === 'named_tags.categories.lvl0') {
      link = await buildLink(breadCrumbsArr[0]?.trim());
      ret.push({
        link: link,
        text: breadCrumbsArr[0],
      })
      setBreadcrumbs(ret)
      setFlag(false)
    }
  };

  const setBredCrumb = async () => {
    await createBreadcrumbLinks();
  }

  React.useEffect(() => {
    /* data must contain either level0, 1 or 2 level attribute */
    if((lastData?.attribute === "named_tags.categories.lvl0" || lastData?.attribute === "named_tags.categories.lvl1" || lastData?.attribute === "named_tags.categories.lvl2")&&!lastData?.refinements[0]?.value?.includes("undefined")) {
      //OS-4968 #timeout is added to prevent multiple function call
      if(!flag){
        setFlag(true)
        setTimeout(() => {
          setBredCrumb();
        }, 1000);
      }
    }
  }, [lastData]);

  // Render the breadcrumbs or null based on shouldHideBreadcrumbs state
  return shouldHideBreadcrumbs ? (
    // If shouldHideBreadcrumbs is true, render the breadcrumbs section
    <section className={`${styles.breadcrumb_sec}`}>
      <div className="container-fluid mw-1440">
        <div className="row">
          <nav className="grid-md-12 grid-sm-12" aria-label="breadcrumbs">
            <ol className={`xx-small`}>
              {breadcrumbs.map((breadcrumb, index) => (
                <li key={index}>
                  {index === breadcrumbs.length - 1 ? (
                    <span>
                      {breadcrumb.text
                        ? breadcrumb.text.charAt(0).toUpperCase() +
                          breadcrumb.text.slice(1).replaceAll("-", " ")
                        : null}
                    </span>
                  ) : (
                    <a href={breadcrumb.link} tabIndex={0} className="breadcrumb-link">
                      {breadcrumb.text
                        ? breadcrumb.text.charAt(0).toUpperCase() +
                          breadcrumb.text.slice(1).replaceAll("-", " ")
                        : null}
                    </a>
                  )}
                  {index < breadcrumbs.length - 1 }
                </li>
              ))}
            </ol>
          </nav>
        </div>
      </div>
    </section>
  ) : <></>;  // If shouldHideBreadcrumbs is false, return null (hide breadcrumbs)
}

export default BreadCrumb